import { DownloadButton } from '@/containers/DownloadButton'
import { useGetProductSheets } from '@/hooks/useProductSheets'
import { Stack } from '@chakra-ui/react'
import type { Offer } from 'BrokerTsLib/src/dtos'
import type { Insurer } from 'BrokerTsLib/src/enums'


export const ProductSheetTab = ({ offer }: { offer: Offer }) => {
    const productSheets = useGetProductSheets(offer.insurerId as Insurer)

    return (
        <Stack alignItems='start'>
            {productSheets?.map((sheet) => (<DownloadButton key={sheet.label} as={'a'} target='_blank' href={sheet.url}>{sheet.label}</DownloadButton>))}
        </Stack>
    )
}

